import type {Component} from 'grapesjs';
import EditorBaseComponentVO, {type ComponentVOProps} from './editorbasecomponentvo';

export interface StepButtonsVOOptions {
  defaults?: number | string;
  step?: number;
  component?: Component | null;
  isResponsive?: boolean;
}

export interface StepButtonsVOProps extends ComponentVOProps {
  step: number;
}

export default class PMWStepButtons extends EditorBaseComponentVO {
  private stepValue: number;

  constructor(
    property: string,
    propertyLabel: string,
    units: string | string[],
    min: number,
    max: number,
    opts: StepButtonsVOOptions = {}
  ) {
    const options = {
      defaults: 0,
      step: 1,
      component: null,
      isResponsive: false,
      ...opts,
    };

    super(
      property,
      propertyLabel,
      units,
      min,
      max,
      options.defaults,
      window.PMW.emails.styles.ID_STEP_BUTTONS,
      false,
      options.component,
      options.isResponsive
    );

    this.stepValue = options.step;
  }

  get step(): number {
    return this.stepValue;
  }

  set step(value: number) {
    this.stepValue = value;
  }

  override toObject(): StepButtonsVOProps {
    const baseObj = super.toObject();
    return {
      ...baseObj,
      step: this.step,
    };
  }
}